export default __webpack_public_path__ + "static/media/rvt.5c9d914c.png";